import { ApiError } from "@hp/api-client";
import * as api from "@hp/api-client";
import type { LoginResponse, User } from "@hp/api-client";
import { USE_MOCK_DATA } from "./config";
import { checkMockPassword, findUserByEmail, issueMockToken, resolveMockToken } from "../mocks/authStore";

function delay<T>(value: T, ms = 300): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}

/** Exchanges an email/password for a bearer token plus the authenticated user. */
export async function login(email: string, password: string): Promise<LoginResponse> {
  if (!USE_MOCK_DATA) return api.login({ email, password });

  const user = findUserByEmail(email);
  if (!user || !user.is_active || !checkMockPassword(email, password)) {
    throw new ApiError("Incorrect email or password", 401, "/auth/login", null);
  }
  user.last_login_at = new Date().toISOString();
  return delay({ access_token: issueMockToken(user), token_type: "bearer", user: { ...user } });
}

/**
 * Resolves the user a token belongs to - called on startup to hydrate a
 * persisted session. See `@hp/workbench`'s `data/auth.ts` for why the
 * token itself is unused on the real-mode branch.
 */
export async function getCurrentUser(token: string): Promise<User> {
  if (!USE_MOCK_DATA) return api.getCurrentUser();

  const user = resolveMockToken(token);
  if (!user || !user.is_active) {
    throw new ApiError("Invalid token", 401, "/auth/me", null);
  }
  return delay({ ...user });
}
